// Lightweight dev-only logger. In production builds (`NODE_ENV === 'production'`)
// all calls become no-ops so sensitive debug info is never exposed in user consoles.
const isDev = process.env.NODE_ENV !== 'production';

const noop = () => {};

const logger = {
  log: isDev ? (...args) => console.log(...args) : noop,
  info: isDev ? (...args) => console.info(...args) : noop,
  warn: isDev ? (...args) => console.warn(...args) : noop,
  error: isDev ? (...args) => console.error(...args) : noop,
  debug: isDev ? (...args) => console.debug(...args) : noop,
};

export default logger;
